//
// Link.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";
import "../BaseModel";
import "../../resources/network/HttpVerb";

var Link = createModule("commons::Link", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    ,
    {
        itemType: 7,
        responseType: 7,
        grantTypes: [7],
        method: 4,
        rel: 7,
        href: 7,
        type: 7,
        uri: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Link;
